const delayCodesData = [
  {
    number: 0,
    title: 'Internal',
    info: 'Delay codes starting with 0 are used for internal airline purposes. Airlines are free to define these codes and to determine particular application fields. However the following codes are standard, even if some airlines do not use them and create their own customized delay codes.',
    codes: [
      {
        code: '00-05',
        description:
          'These codes are left blank so that each airline may develop codes specifically to meet their own individual requirements.',
      },
      {
        code: '06',
        description: 'No gate/stand availability due to own airline activity.',
      },
      {
        code: '07',
        description: 'Aircraft connection by maintenance.',
      },
      {
        code: '08',
        description:
          'Aircraft connection by miscellaneous, traffic, marketing flight operations, ground  handling, cabin services, etc.',
      },
      {
        code: '09',
        description:
          'Scheduled ground time less than declared minimum ground time.',
      },
    ],
  },
  {
    number: '1',
    title: 'Passenger/Baggage',
    info: 'These Codes are used to describe delays caused by Passenger and Baggage handling.',
    codes: [
      {
        code: '11',
        description: 'Late check-in, acceptance of passengers after deadline.',
      },
      {
        code: '12',
        description: 'Late Check-in, congestion in check-in area.',
      },
      {
        code: '13',
        description: 'Check-in error.',
      },
      {
        code: '14',
        description: 'Oversales, booking errors.',
      },
      {
        code: '15',
        description:
          'Boarding, discrepancies and paging, missing checked-in passenger at gate.',
      },
      {
        code: '16',
        description:
          'Commercial Publicity, Passenger Convenience, VIP, Press, Ground meals and missing personal items.',
      },
      {
        code: '17',
        description:
          'Catering order, late or incorrect order given to supplier.',
      },
      {
        code: '18',
        description: 'Baggage processing, sorting, etc.',
      },
      {
        code: '19',
        description:
          'Reduced Mobility, Boarding/Deboarding of passengers with reduced mobility.',
      },
    ],
  },
  {
    number: '2',
    title: 'Cargo/Mail',
    info: 'These Codes are used to describe delays caused by Cargo (21-26) and Mail Handling (27-29).',
    codes: [
      {
        code: '21',
        description: 'Documentation, errors, etc.',
      },
      {
        code: '22',
        description: 'Late positioning.',
      },
      {
        code: '23',
        description: 'Late acceptance.',
      },
      {
        code: '24',
        description: 'Inadequate packing.',
      },
      {
        code: '25',
        description: 'Oversales, booking errors.',
      },
      {
        code: '26',
        description: 'Late preparation in warehouse.',
      },
      {
        code: '27',
        description: 'Mail Oversales, packing, etc.',
      },
      {
        code: '28',
        description: 'Mail Late positioning.',
      },
      {
        code: '29',
        description: 'Mail Late acceptance.',
      },
    ],
  },
  {
    number: '3',
    title: 'Handling',
    info: 'These Codes are used to describe delays caused by aircraft and ramp handling.',
    codes: [
      {
        code: '31',
        description:
          'Aircraft documentation late or inaccurate, weight and balance (Loadsheet), general declaration, passenger manifest, etc.',
      },
      {
        code: '32',
        description:
          'Loading, Unloading, bulky/special load, cabin load, lack of loading staff.',
      },
      {
        code: '33',
        description:
          'Loading Equipment, lack of or breakdown, e.g. container pallet loader, lack of staff.',
      },
      {
        code: '34',
        description:
          'Servicing Equipment, lack of or breakdown, lack of staff, e.g. steps.',
      },
      {
        code: '35',
        description: 'Aircraft Cleaning.',
      },
      {
        code: '36',
        description: 'Fuelling, Defuelling, fuel supplier.',
      },
      {
        code: '37',
        description: 'Catering, late delivery or loading.',
      },
      {
        code: '38',
        description: 'ULD, Containers, pallets, lack of or breakdown.',
      },
      {
        code: '39',
        description:
          'Technical equipment, lack of or breakdown, lack of staff, e.g. pushback.',
      },
    ],
  },
  {
    number: '4',
    title: 'Technical',
    info: 'These codes are used to describe technical delay reasons.',
    codes: [
      {
        code: '41',
        description: 'Aircraft defects.',
      },
      {
        code: '42',
        description: 'Scheduled maintenance, late release.',
      },
      {
        code: '43',
        description:
          'Non-scheduled maintenance, special checks and / or additional works beyond normal maintenance.',
      },
      {
        code: '44',
        description: 'Spares and maintenance equipment, lack of or breakdown.',
      },
      {
        code: '45',
        description:
          'AOG (Aircraft on ground for technical reasons) Spares, to be carried to another station.',
      },
      {
        code: '46',
        description: 'Aircraft change for technical reasons.',
      },
      {
        code: '47',
        description:
          'Standby aircraft, lack of planned standby aircraft for technical reasons.',
      },
      {
        code: '48',
        description: 'Scheduled cabin configuration and version adjustment.',
      },
    ],
  },
  {
    number: '5',
    title: 'Damage/failure',
    info: 'These Codes are used to describe damage to aircraft and automated equipment failure.',
    codes: [
      {
        code: '51',
        description:
          'Damage during flight operations, bird or lightning strike, turbulence, heavy or overweight landing.',
      },
      {
        code: '52',
        description:
          'Damage during ground operations, collisions (other than during taxiing), loading/offloading damage, contamination, towing, extreme weather conditions.',
      },
      {
        code: '55',
        description:
          'Departure Control System, Check-in, weight and balance (loadcontrol), computer system error, baggage sorting, gate-reader error or problems.',
      },
      {
        code: '56',
        description: 'Cargo preparation/documentation system.',
      },
      {
        code: '57',
        description: 'Flight plans.',
      },
      {
        code: '58',
        description: 'Other computer systems.',
      },
    ],
  },
  {
    number: '6',
    title: 'Operation',
    info: 'These codes are assigned to Operations and Crew caused delays.',
    codes: [
      {
        code: '61',
        description:
          'Flight plan, late completion or change of flight documentation.',
      },
      {
        code: '62',
        description: 'Operational requirements, fuel, load alteration.',
      },
      {
        code: '63',
        description: 'Late crew boarding or departure procedures.',
      },
      {
        code: '64',
        description: 'Flight deck crew shortage, crew rest.',
      },
      {
        code: '65',
        description: 'Flight deck crew special request or error.',
      },
      {
        code: '66',
        description: 'Late cabin crew boarding or departure procedures.',
      },
      {
        code: '67',
        description: 'Cabin crew shortage.',
      },
      {
        code: '68',
        description: 'Cabin crew error or special request.',
      },
      {
        code: '69',
        description: 'Captain request for security check, extraordinary.',
      },
    ],
  },
  {
    number: '7',
    title: 'Weather',
    info: 'These Codes are used for Air Traffic Control (ATC) Restrictions (81-84) and Airport or Governmental Authorities caused delays.',
    codes: [
      {
        code: '71',
        description: 'Departure station.',
      },
      {
        code: '72',
        description: 'Destination station.',
      },
      {
        code: '73',
        description: 'En route or Alternate.',
      },
      {
        code: '75',
        description:
          'De-Icing of aircraft, removal of ice/snow, frost prevention.',
      },
      {
        code: '76',
        description: 'Removal of snow/ice/water/sand from airport/runway.',
      },
      {
        code: '77',
        description: 'Ground handling impaired by adverse weather conditions.',
      },
    ],
  },
  {
    number: '8',
    title: 'Air traffic control',
    info: 'These Codes explain weather caused delays.',
    codes: [
      {
        code: '81',
        description: 'ATC restriction en-route or capacity.',
      },
      {
        code: '82',
        description:
          'ATC restriction due to staff shortage or equipment failure en-route.',
      },
      {
        code: '83',
        description: 'ATC restriction at destination.',
      },
      {
        code: '84',
        description: 'ATC restriction due to weather at destination.',
      },
      {
        code: '85',
        description: 'Mandatory security.',
      },
      {
        code: '86',
        description: 'Immigration, Customs, Health.',
      },
      {
        code: '87',
        description:
          'Airport Facilities, parking stands, ramp congestion, buildings, gate limitations.',
      },
      {
        code: '88',
        description:
          'Restrictions at airport of destination, airport/runway closed due obstruction, industrial action, staff shortage, political unrest, noise abatement, night curfew, special flights.',
      },
      {
        code: '89',
        description:
          'Restrictions at airport of departure, airport/runway closed due obstruction, industrial action, staff shortage, political unrest, noise abatement, night curfew, special flights, start-up and pushback.',
      },
    ],
  },
  {
    number: '9',
    title: 'Miscellaneous',
    info: 'Codes used for reactionary reasons or miscellaneous.',
    codes: [
      {
        code: '91',
        description:
          'Passenger or Load Connection, awaiting load or passengers from another flight. Protection of stranded passengers onto a new flight.',
      },
      {
        code: '92',
        description: 'Through Check-in error, passenger and baggage.',
      },
      {
        code: '93',
        description:
          'Aircraft rotation, late arrival of aircraft from another flight or previous sector.',
      },
      {
        code: '94',
        description: 'Cabin crew rotation.',
      },
      {
        code: '95',
        description:
          'Crew rotation, awaiting crew from another flight (flight deck or entire crew).',
      },
      {
        code: '96',
        description:
          'Operations control, rerouting, diversion, consolidation, aircraft change for reasons other than technical.',
      },
      {
        code: '97',
        description: 'Industrial action within own airline.',
      },
      {
        code: '98',
        description: 'Industrial action outside own airline, excluding ATS.',
      },
      {
        code: '99',
        description: 'Miscellaneous, not elsewhere specified.',
      },
    ],
  },
];

export default delayCodesData;
